module.exports = __webpack_public_path__ + "media/react/assets/gradient_play_button-b8f2c166af8c124bdd5201ee20717b7d.svg";